import React from 'react';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import ProjectListWrapper from '../components/ProjectListWrapper/ProjectListWrapper';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuth } from 'src/features/authorization';
import { DevelopmentProjectListItemDto } from 'src/api/v2';
import useDevelopmentProjects from '../hooks/use-development-projects';
import NoAccess from 'src/components/NoAccess/NoAccess';

const DevelopmentProjects: React.FC = () => {
  const { t: tProjects } = useTranslation('projects');
  const { t: tPageTitles } = useTranslation('pageTitles');

  const { checkAccess } = useAuth();

  const { developmentProjectsQuery } = useDevelopmentProjects();

  if (developmentProjectsQuery.isFetching) {
    return <LoadingPage text={tPageTitles('inFinancedProjects')} />;
  }

  if (!checkAccess('DevelopmentProject').read) return <NoAccess />;

  return (
    <ContentPage title={tPageTitles('inFinancedProjects')}>
      <p>
        {tProjects('inFinancedProjectsDescription')}{' '}
        {checkAccess('PortalProject').read && (
          <span>
            {tProjects('seeOtherProjects')}{' '}
            <Link to="/projects/own-projects">{tProjects('ownProjects')}</Link>
          </span>
        )}
      </p>

      <ProjectListWrapper<DevelopmentProjectListItemDto>
        isFetching={developmentProjectsQuery.isFetching}
        projects={developmentProjectsQuery.data || []}
        hideCreateButton
        projectType="development"
      />
    </ContentPage>
  );
};

export default DevelopmentProjects;
